import React, { Component } from 'react';
import { Col, Panel, Form, FormGroup, Checkbox, Button } from 'react-bootstrap';
import { ref, uid } from '../../utils/firebase.js';

class Notification extends Component {
  constructor() {
    super();
    this.state = {
      isChecked: false,
      optOut: false,
      loaded: false
    };
    this.update = this.update.bind(this)
    this.toggleChange = this.toggleChange.bind(this)
  }

  componentDidMount() {
    const user = ref.child(`users/${uid}/info`);
    user.on('value', snap => {
      this.setState({
        isChecked: snap.val().optOut || false,
        optOut: snap.val().optOut || false,
        loaded: true
      });
    });
  }

  toggleChange(e) {
    var data = this.state;
    data.isChecked = !data.isChecked;
    this.setState(data);
  }

  update(e) {
    e.preventDefault();
    ref.child(`users/${uid}/info/optOut`).set(document.getElementById('notify').checked);
  }

  render() {
    return (
      <Col sm={6}>
        <Panel header={<h3>Notifications</h3>} bsStyle="primary">
          <h4 className="login-text">We will notify you via e-mail when drafting begins.</h4>
          <h5 className="login-text">Click below to opt-out.</h5>

          <Form horizontal>
            <FormGroup>
              <Col smOffset={2} sm={10}>
                <Checkbox checked={this.state.isChecked} onChange={this.toggleChange} id="notify">No, I'll check back on my own</Checkbox>
              </Col>
            </FormGroup>

            <FormGroup>
              <Col smOffset={2} sm={10}>
                <Button bsStyle="info" onClick={this.update} type="submit" active={!this.state.loaded}>
                  Save
                </Button>
              </Col>
            </FormGroup>
            <FormGroup>
              <Col smOffset={2} sm={10} className={ this.state.loaded ? "show" : "hidden"}>
                { this.state.optOut ? <h5 className="secondary-text-color">Cool, we won't bug you.</h5> : "" }
              </Col>
              <Col smOffset={2} sm={10} className={ !this.state.loaded ? "show" : "hidden"}>
                <h5 className="primary-text-color">Loading...</h5>
              </Col>
            </FormGroup>
          </Form>
        </Panel>
      </Col>
    );
  }

}

export default Notification;



// WEBPACK FOOTER //
// ./src/components/Home/Notification.js